import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const CustomModulesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CustomModules",
    children: /*#__PURE__*/_jsx("path", {
      d: "M2.97 2.93c-.44.33-.51.65-.29 1.64s.66 4.95 3.18 6.35c2.53 1.41 6.1-2.09 4.53-4.57S6.03 4.69 5.17 3.87s-1.3-1.51-2.2-.95ZM13.38 9.51l.06.06c.37.37.37.96 0 1.33l-2.85 2.85c-.37.37-.96.37-1.33 0l-.06-.06a.936.936 0 0 1 0-1.33l2.85-2.85c.37-.37.97-.37 1.33 0M29.23 25.32l-9.59-9.58 4.04-4.04c.29.06.63.09.97.09 2.71 0 4.9-2.2 4.9-4.91v-.02c0-.62-.12-1.21-.31-1.75l-2.36 2.31c-.32.32-.77.54-1.28.54s-.95-.21-1.28-.54c-.38-.38-.63-.92-.63-1.52s.24-1.13.63-1.52l2.1-2.03c-.53-.21-1.13-.32-1.78-.32a4.912 4.912 0 0 0-4.82 5.86v-.03l-4.05 4.04-.58-.58-3.79 3.96.51.5-9.11 9.08c-.5.51-.8 1.18-.8 1.93 0 1.51 1.23 2.73 2.73 2.73.75 0 1.44-.3 1.93-.81l9.09-9.1 9.59 9.57c.5.5 1.18.8 1.93.8 1.51 0 2.73-1.23 2.73-2.73a2.63 2.63 0 0 0-.77-1.93M4.3 27.96a.696.696 0 1 1 0-1.39c.39 0 .7.3.7.69s-.31.7-.7.7"
    })
  }));
};